(ns ui.view.card.survey-processes.event
  (:require
   [re-frame.core :as rf]
   [ui.view.card.model :as common-model]
   [frontend.routing :as routing]
   [frontend.controller.websocket.event :as ws]
   [frontend.state.current-session :as session]
   [common.localization :as loc]
   [ui.fx.toast :as toast]))

;; HACK: Old routing expects the entities in session/entities
;; The old survey profile nev loaded these on mount to the session state
(rf/reg-fx
 ::open-process-fx
 (fn [{:keys [survey-process survey-profile]}]
   (let [process-id (:db/id survey-process)
         profile-id (:db/id survey-profile)
         entities-by-id {process-id survey-process
                         profile-id survey-profile}]
     (swap! session/entities merge entities-by-id)
     (deref session/entities)
     (routing/open-entity process-id :profile-id profile-id))))

(rf/reg-event-fx
 ::open-process
 [rf/trim-v]
 (fn [{:keys [db]} [{:keys [card-state-path]} {:keys [process-id profile-id]}]]
   (let [process (common-model/get-entity db card-state-path process-id)
         profile (common-model/get-entity db card-state-path profile-id)]
     {:fx [[::open-process-fx {:survey-process process
                               :survey-profile profile}]]})))

(rf/reg-event-fx
 ::create-process-success
 [rf/trim-v]
 (fn [{:keys [db]} [{:keys [card-state-path] :as ctx} resp]]
   (let [profile-id (:entity-id ctx)
         profile (common-model/get-entity db card-state-path profile-id)
         process (:body resp)]
     {:fx [[::open-process-fx {:survey-process process
                               :survey-profile profile}]]})))

(defn create-process-error-event-fx-handler
  [_cofx _event]
  {::toast/error (loc/tr :an-error-occurred)})

(rf/reg-event-fx
 ::create-process-error
 [rf/trim-v]
 create-process-error-event-fx-handler)

(rf/reg-event-fx
 ::create-process
 [rf/trim-v]
 (fn [_ [ctx]]
   (let [profile-id (:entity-id ctx)
         data {:entity/type :entity.type/survey-process
               :common/containing-entity profile-id}]
     {::ws/send {:id :entity/create-entity
                 :body data
                 :on-success [::create-process-success ctx]
                 :on-error [::create-process-error ctx]}})))
